import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { responseError } from '../../../helpers/response/ResponseHelper'
import MySelectSearch from '../../UI/form/MySelectSearch'
import { getSuppliersAPI } from '../../../api/supply/supplierAPI'
import { getSupplyBillsAPI } from '../../../api/supply/supplyBillAPI'

const SupplyBillsSearchSelectMain = ({ required, setValidate, setValueForm, forciblyValue, className, status }) => {

    const [value, setValue] = useState(forciblyValue)
    const [query, setQuery] = useState('')
    // console.log('query', query)
  	const [validSelect, setValidSelect] = useState(false)
	const [supplyBills, setSupplyBills] = useState([])
	const [loading, setLoading] = useState(false)

	useEffect(() => {
        if (query && query.length >= 2) {
            getSupplyBills()
        } else {
            setSupplyBills([])
        }
	}, [query])

	useEffect(() => {
		valid()
	}, [required, value])

	const getSupplyBills = () => {
        setLoading(true)
        setSupplyBills([])
		getSupplyBillsAPI({ query, status }).then(data => {
			setSupplyBills(data.supplyBills)
            setLoading(false)
		}).catch(e => {
			// setError(responseError(e))
			console.error(responseError(e))
            setLoading(false)
		})
	}

	const valid = () => {
		if (required) {
			if (value) {
				setValidate(true)
				setValidSelect(true)
			} else {
				setValidate(false)
				setValidSelect(false)
			}
		} else {
			setValidate(true)
			setValidSelect(true)
		}
	}

  return (
	<div className={className}>
		<MySelectSearch
			// optionDefault={}
			// nameField={}
			setQuery={setQuery}
			label={'Рахунок'}
			placeholder={'Введіть для пошуку'}
			labelId={'select__supplyBill-label'}
			id={'select__supplyBill'}
			// value={value ? {id: value, name: suppliers[0].name} : ''}
			value={value}
			onChange = {e => {
				setValueForm(e)
				setValue(e)
			}}
			loading={loading}
			setLoading={setLoading}
			// disabled={}
			// loading={}
			options={
				supplyBills && supplyBills.length > 0 ? 
					supplyBills.map(supplyBill => {
						// return {id: supplier.id, name: getUserName({ user })}
						// return {id: supplyBill.id, name: `${supplyBill.name} (${supplyBill.edrpou})`}
						return {id: supplyBill.id, name: `Рахунок ID: ${supplyBill.id} (${supplyBill.supplier ? supplyBill.supplier.name : ''})`}
						// return {id: supplier.id, name: `${supplier.name}`}
					})
				: []	
			}
		/>
	</div>
  )
}

export default SupplyBillsSearchSelectMain